import React, { useEffect, useState } from 'react';

export default function Countdown(props) {
  const { className, seconds } = props;
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (timeLeft === 0) setTimeLeft(null);
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  return (
    <span className={className}>{timeLeft}</span>
  );
}